
import { afterNextRender, Component, OnDestroy, OnInit, signal, ViewChild } from '@angular/core';
import { TuPedidoComponent } from "./components/tu-pedido/tu-pedido.component";
import { InformacionEntregaComponent } from "./components/informacion-entrega/informacion-entrega.component";
import { ResumenPedidoComponent } from "./components/resumen-pedido/resumen-pedido.component";
import { MetodosPagosComponent } from "../../shared/components/metodos-pagos/metodos-pagos.component";
import { ShopCartService } from '../../shared/components/shop-cart/service/shop-cart.service';
import { PropinaRepartidorComponent } from "./components/propina-repartidor/propina-repartidor.component";

import { ArrowBackComponent } from "../../shared/components/arrow-back/arrow-back.component";
import { TextDetailShopComponent } from '../../shared/components/text-detail-shop/text-detail-shop.component';
import { Subscription } from 'rxjs';
import { PrePurchaseService } from '../../core/service/pre-purchase/pre-purchase.service';
import { LoaderSubitoService } from '../../shared/components/loader-subito/service/loader-subito.service';
import { ModalViewMultiplicadorComponent } from "./components/modal-view-multiplicador/modal-view-multiplicador.component";
import { ShowMultiplicadorService } from '../../core/service/show-multiplicador/show-multiplicador.service';
import { AppState } from '../../store/app.state';
import { Store } from '@ngrx/store';
import { DriverTourService } from '../../core/service/driver-tour/driver-tour.service';

@Component({
  selector: 'features-detail-orden-checkout',
  imports: [TuPedidoComponent, InformacionEntregaComponent, ResumenPedidoComponent, MetodosPagosComponent, PropinaRepartidorComponent, TextDetailShopComponent, ArrowBackComponent, ModalViewMultiplicadorComponent],
  templateUrl: './detail-orden-checkout.component.html',
  styleUrl: './detail-orden-checkout.component.css'
})
export class DetailOrdenCheckoutComponent implements OnInit, OnDestroy {
  isItemsCart = signal(false);
  isLoading = signal(true);
  @ViewChild('modalMultiplicador') modalMultiplicador!: ModalViewMultiplicadorComponent;
  showMultiplicador = signal(false);
  canBuy = signal(false);
  private subscriptions: Subscription = new Subscription();
  constructor(
    private shopCartService: ShopCartService,
    private prePurchaseService: PrePurchaseService,
    private loaderService: LoaderSubitoService,
    private showMultiplicadorService: ShowMultiplicadorService,
    private store: Store<AppState>,
    private driverTourService: DriverTourService,
  ) {

  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
    this.driverTourService.destroy();
  }
  ngOnInit(): void {
    // Simular tiempo de carga inicial
    setTimeout(() => {
      this.isLoading.set(false);
    }, 1500);

    this.shopCartService.getTotalItems().subscribe(totalItems => {
      const hasItems = totalItems > 0;
      this.isItemsCart.set(hasItems);

      // Move the modal logic inside the subscription after isItemsCart is set
      if (hasItems) {
        this.prePurchaseService.getCoordinates().subscribe(coordinates => {
          this.showMultiplicador.set(this.showMultiplicadorService.getShowMultiplicador());
          // console.log('valor de multiplicador', this.showMultiplicador());
          this.showPayments();
          if (this.showMultiplicador()) {
            // console.log('Intentando abrir modal...');
            // console.log('modalMultiplicador existe?', !!this.modalMultiplicador);

            // Use setTimeout to ensure the view is initialized
            setTimeout(() => {
              if (this.modalMultiplicador) {
                // console.log('Llamando openModal()');
                this.modalMultiplicador.openModal();
              } else {
                console.error('modalMultiplicador no está inicializado');
              }
            }, 100);
          }
        });
      }
    });


  }
  onSelectedAddressChange(address: any | null): void {
    this.loaderService.showLoader();
    setTimeout(() => {
      this.loaderService.hideLoader();
    }, 1000);
  }



  showPayments(): void {
    this.store.select(state => state.balance).subscribe(balance => {
      const parsedBalance = Number(balance.balance);
      // console.log('[Checkout] Balance recibido:', balance.balance, 'parseado:', parsedBalance);
      // Nueva regla solicitada:
      // - Mostrar popup SOLO cuando balance <= -10
      // - En cualquier otro caso (> -10), NO mostrar popup y permitir (canBuy = true)
      if (parsedBalance <= -10) {
        this.canBuy.set(false);
        // console.log('[Checkout] Balance <= -10, BLOQUEADO, canBuy:', this.canBuy());
        setTimeout(() => {
          if (!this.driverTourService.isActive()) {
            // console.log('Mostrando popup de balance negativo');
            this.driverTourService.showNegativeBalancePopup();
          } else {
            // console.log('Popup/tour ya activo, no duplicar');
          }
        }, 1000);
      } else {
        this.canBuy.set(true);
        // console.log('[Checkout] Balance > -10, PERMITIDO, canBuy:', this.canBuy());
      }
    });
  }


}


